const STATUS_MAP = {
  // completion / positive
  'completed': 'cg',
  'verification completed': 'cg',
  'verified': 'cg',
  'clear': 'cg',
  'top-up': 'cg',
  'paid': 'cg',
  'refund': 'cb',
  'sent': 'cg',

  // in-progress / info
  'in progress': 'cb',
  'in-progress': 'cb',
  'check in progress': 'cb',

  // warning / attention
  'need info': 'ca',
  'need information': 'ca',
  'insufficient': 'ca',
  'additional docs': 'ca',
  'additional_docs': 'ca',
  'l1 insuff': 'ca',
  'l1 insuff.': 'ca',
  'addl. charge': 'ca',
  'discrepancy': 'ca',
  'interim': 'ca',

  // danger / action needed
  'approval needed': 'cr',
  'ce awaited': 'cr',
  'debit': 'cr',
  'stopped': 'cr',
  'cancelled': 'cr',
  'invite cancelled': 'cr',

  // neutral / grey
  'pending': 'cgr',
  'de pending': 'cgr',
  'de pending.': 'cgr',
  'de_pending': 'cgr',
  'invited': 'cor',
  'pending from finance': 'cor',
  'invited candidates': 'cgr',
  'standard': 'cn',
  'standard plus': 'cn',
  'std plus': 'cn',
  'premium': 'cn',
  'executive': 'cn',
  'direct upload': 'cn',

  // client status / onboarding status (View Clients page)
  'active': 'cg',
  'inactive': 'ca',
  'approved': 'cg',
  'partner created': 'cgr',
  'verification pending': 'ca',
};

export default function Chip({ label, className }) {
  const key = (label || '').toLowerCase().trim();
  const cls = className || STATUS_MAP[key] || 'cn';
  return <span className={`chip ${cls}`}>{label}</span>;
}
